import React from 'react'
import {
  Switch,
  NavLink,
  Route,
  Redirect,
} from 'react-router-dom'
import Jobs from '../../pages/Jobs'
import JobInfo from '../../pages/JobInfo'
import VarianceProgress from '../../pages/VarianceProgress'
import Dealers from '../../pages/Dealers'
import Employees from '../../pages/Employees'
import Report from '../../pages/Report'
import Profile from '../../pages/Profile'
import Reports from '../../pages/Reports/index.store'
import IconLogoText from '../../components/icons/IconLogoText'
import IconJobs from '../../components/icons/IconJobs'
import IconDealers from '../../components/icons/IconDealers'
import IconEmployees from '../../components/icons/IconEmployees'
import IconReports from '../../components/icons/IconReports'
import IconProfile from '../../components/icons/IconProfile'
import DealerInfo from '../../pages/DealerInfo'
import EmployeeInfo from '../../pages/EmployeeInfo'


import './index.css'
import Example from '../PrintVarianceComponent'
import PrintVarianceComponent from '../PrintVarianceComponent'

const MainFrame = () => {
  return (
    <div className="main-frame">
      <nav className="main-frame__sidebar">
        <div className="sidebar__logo sidebar__item">
          <IconLogoText />
        </div>
        <div className="sidebar__nav">
          <ul className="nav__list">
            <li className="nav__item sidebar__item">
              <NavLink to="/jobs" className="nav__link">
                <IconJobs className="link__icon" />
                <span className="link__title">Jobs</span>
              </NavLink>
            </li>
            <li className="nav__item sidebar__item">
              <NavLink to="/dealers" className="nav__link">
                <IconDealers className="link__icon" />
                <span className="link__title">Dealers</span>
              </NavLink>
            </li>
            <li className="nav__item sidebar__item">
              <NavLink to="/employees" className="nav__link">
                <IconEmployees className="link__icon" />
                <span className="link__title">Employees</span>
              </NavLink>
            </li>
            <li className="nav__item sidebar__item">
              <NavLink to="/reports" className="nav__link">
                <IconReports className="link__icon" />
                <span className="link__title">Reports</span>
              </NavLink>
            </li>
            <li className="nav__item sidebar__item">
              <NavLink to="/profile" className="nav__link">
                <IconProfile className="link__icon" />
                <span className="link__title">Profile</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <main className="main-frame__main">
        <Switch>
          <Route path="/jobs" component={Jobs} exact />
          <Route path="/jobs/:jobId/reports/:reportId" component={Report} />
          <Route path="/employees/:employeeId/reports/:reportId" component={Report} />
          <Route path="/dealers/:dealerId/reports/:reportId" component={Report} />
          <Route path="/jobs/:jobId/variance" component={VarianceProgress} />
          <Route path="/jobs/:jobId" component={JobInfo} />
          <Route path="/dealers" component={Dealers} exact />
          <Route path="/dealers/:dealerId" component={DealerInfo} />
          <Route path="/employees" component={Employees} exact />
          <Route path="/employees/:employeeId" component={EmployeeInfo} />
          <Route path="/profile" component={Profile} />
          <Route path="/reports" component={Reports} />
          <Route path="/generic/general/reports/:reportId" component={Report} />

          {/*<Route path="jobs/:jobId/:reportName" component={TableReports} />*/}


          <Redirect from="/" to="/jobs" />
        </Switch>
      </main>
    </div>
  )
}

export default MainFrame
